"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var compare_versions_component_1 = require("./../../compare-versions/compare-versions.component");
var material_1 = require("@angular/material");
var router_1 = require("@angular/router");
var common_1 = require("@angular/common");
var service_service_1 = require("src/app/Services/service.service");
var core_1 = require("@angular/core");
var material_2 = require("@angular/material");
var action_service_1 = require("./../../../action.service");
var WebFont = require("webfontloader");
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(dialog, _location, router, service, _actionService, renderer) {
        var _this = this;
        this.dialog = dialog;
        this._location = _location;
        this.router = router;
        this.service = service;
        this._actionService = _actionService;
        this.renderer = renderer;
        this.enableSubscription = false;
        this.enableCompareVersion = false;
        this.enableLetOurPros = false;
        this.enableAdvertiseWithUs = false;
        this.isMenuOpen = false;
        this.pageName = null;
        this.needLoadedCount = 0; //need 3, 2 font and logo
        this.enableSubscription = service.enableSubscription;
        this.enableCompareVersion = service.enableCompareVersion;
        this.enableLetOurPros = service.enableLetOurPros;
        this.enableAdvertiseWithUs = service.enableAdvertiseWithUs;
        this.renderer.listen('window', 'click', function (e) {
            var snavEl = _this.snavHTMLElement.nativeElement;
            if (e.target !== _this.menuButton.nativeElement && e.target !== snavEl && !snavEl.contains(e.target)) {
                _this.snav.close();
            }
        });
        WebFont.load({
            google: { families: ['Material Icons', 'Material Icons Outline'], },
            custom: {
                families: ['ETmodules']
            },
            fontactive: function (familyName, fvd) {
                if (familyName == "Material Icons" || "ETmodules")
                    _this.upAndCheckLoadedCount();
            },
        });
    }
    Object.defineProperty(HeaderComponent.prototype, "strBlogUrl", {
        get: function () {
            return this.service.advService.blogURL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderComponent.prototype, "showUpgradeToPremiumLine", {
        get: function () {
            if (!this.service.userService.isAuthenticated()) {
                return true;
            }
            return !(this.service.userService.isPremium() || this.service.userService.isAdmin() || this.service.userService.isDemo());
        },
        enumerable: true,
        configurable: true
    });
    HeaderComponent.prototype.upAndCheckLoadedCount = function () {
        this.needLoadedCount++;
        if (this.needLoadedCount == 3) {
            this.service.aplicationIsReady = true;
        }
    };
    HeaderComponent.prototype.getRouterUrl = function () {
        return this.router.url;
    };
    ;
    HeaderComponent.prototype.closeSnav = function () {
        window.scrollTo(0, 0);
        this.snav.close();
    };
    HeaderComponent.prototype.ngOnInit = function () {
    };
    HeaderComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.subscription = this.service.observablePageName
            .subscribe(function (item) {
            _this.pageName = item;
        });
    };
    HeaderComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    HeaderComponent.prototype.locationBack = function () {
        if (window.history.length > 1) {
            this._location.back();
        }
        else {
            this.router.navigate(['/']);
        }
        document.getElementById('scroll-view-content').scrollTop = 0;
    };
    HeaderComponent.prototype.showCompareVersionsDialog = function () {
        var item = this.dialog.open(compare_versions_component_1.MobileCompareVersionsComponent, {
            width: '1000%',
            maxHeight: '100%',
            height: "82vh",
            panelClass: "CompareVersionsComponent-panel",
            data: {
                isPopup: true
            }
        });
        item.componentInstance.isPopup = true;
        return false;
    };
    return HeaderComponent;
}());
exports.HeaderComponent = HeaderComponent;
